import { CHART_COLORS } from 'domains/Statistics/utils';

export const SHIPPING_SUMMARY_COMBINED_COLORS = {
  revenueByShippingGateway: CHART_COLORS.seaGreen,
  salesByShippingGateway: CHART_COLORS.darkPurple,
  revenueByFreeShipping: CHART_COLORS.deepPurple,
  salesByFreeShipping: CHART_COLORS.electricBlue,
};
